import * as lscache from "lscache";
import {getRequest, postRequest, ResponseParseType} from "@web2/ap-request";

import {APLocalStorageKeys} from "./ls_cache_keys";

export const getAuthorizedRequest = async (apiLink: string) => {
    const storedUserToken = lscache.get(APLocalStorageKeys.USER_DATA)?.apikey;
    if (!storedUserToken) {
        return false;
    }
    return getRequest({}, apiLink, ResponseParseType.JSON, {Authorization: "Token " + storedUserToken});
};

export const postAuthorizedRequest = async (apiLink: string, data: Record<string, unknown>) => {
    const storedUserToken = lscache.get(APLocalStorageKeys.USER_DATA)?.apikey;
    if (!storedUserToken) {
        return false;
    }
    return postRequest({}, apiLink, data, ResponseParseType.TEXT, {Authorization: "Token " + storedUserToken});
};

const fileRequestHeaders = {
    xlsx: {
        Accept: "application/xlsx",
        "Content-Type": "application/xlsx"
    }
};

export const downloadFileAuthorized = (downloadLink: string, fileType: keyof typeof fileRequestHeaders) => {
    const storedUserToken = lscache.get(APLocalStorageKeys.USER_DATA)?.apikey;
    if (!storedUserToken) {
        return false;
    }
    return getRequest({}, downloadLink, ResponseParseType.BLOB, {
        Authorization: "Token " + storedUserToken,
        ...fileRequestHeaders[fileType]
    })
        .then((blob) => {
            // response handling to actually download the file borrowed from https://stackoverflow.com/questions/32545632/how-can-i-download-a-file-using-window-fetch
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "eksport-zgloszen.xlsx";
            document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
            a.click();
            a.remove(); //afterwards we remove the element again
            return true;
        })
        .catch((e) => {
            return false;
        });
};
